define(function(require) {
	const Marionette = require('backbone.marionette');
	const $ = require('jquery');
	const Radio = require('backbone.radio');
	const LoginChannel = Radio.channel('LoginChannel');
	const ViewManager = require('civicsUtils/view_manager');
	const SigninLayoutView = require('./v_lov_login_signin');

	const LoginStatusModel = require('civicsModels/login_status_model');

	const tpl = require('./templates/t_lov_login.hbs');

	return Marionette.LayoutView.extend({
		regions: {
			SigninLayoutViewRegion: '.signin-region',
		},
		ui:{
			loginRegionDivs:'.login-region',
			signInMessages: '.signin-messages'
		},
		childEvents:{
		},
		views:{},
		initializeReturnUrl:function() {
			if (this.config.return) {
				this.config.loginRedirectPage = this.config.return.convertToReturnUrl();
			}
		},
		initialize: function(options) {
			var self = this;
			this.config = options.config;
			this.config.isModal = options.isModal;
			this.config.isRedirect = options.isRedirect;
			this.config.relayState = options.relayState;
			this.initializeReturnUrl();
			this.config.globalConfig = ViewManager.globalConfig();
			if (this.config.globalConfig.get('login')) {
				const lc = ViewManager.globalConfig().get('login').attributes;
				this.config = _.extend(this.config, {
				});
			}
			this.cancelCallback = options.cancelCallback;
			this.cancelCallbackOptions = options.cancelCallbackOptions;
			this.okCallback = options.okCallback;
			this.okCallbackOptions = options.okCallbackOptions;

			let timenow = Date.now();

			// setup radio channels
			LoginChannel.comply('go:checkStatus', this.goCheckStatus.bind(this));
			LoginChannel.comply('finalize:Authentication', this.finalizeAuthentication.bind(this));
			LoginChannel.reply('original:settings', function() {
				return this.settings;
			}, this);

			// settings
			this.settings = {
				username: '',
			};

		},
		onShow: function() {
			this.showSignin();
		},
		goCheckStatus: function(loginView) {
			var statusModel = new LoginStatusModel();
			var self = this;
			ViewManager.loading(true);
			statusModel.fetch({
				success: _.bind(function(model, response) {
					ViewManager.loading(false);
					if (__DEV__) console.log('v_lov_login_sub.js - loginStatus success', model, response);
					// Save this user
					App.user.id = response.data.contactId.id;

					this.finalizeAuthentication();

				}, this),
				error: _.bind(function(model, response) {
					ViewManager.loading(false);
					if (__DEV__) console.log('loginStatus error', model, response);
					if( response.responseText.indexOf('Read timed out') >= 0) {
						self.timeOutError(loginView);
					}
					LoginChannel.command('go:authenticated');
				}, this),
			});
		},
		timeOutError:function(loginView){
			var error = {};
			error.validationError = { password: i18n.t('CIVICS.LOGIN.TIMED_OUT_ERROR') };
			ViewManager.errorToWindow(error, loginView);

		},

		showSignin: function() {
			// create layout views
			this.signinLayoutView = new SigninLayoutView({
				config: this.config
			});
			this.SigninLayoutViewRegion.show(this.signinLayoutView);

			//If there are any messages in the session storage, we need to show those
			var errorMessage = App.sessionStorage.get('CIVICS', 'SSO_ERROR');
			if( errorMessage && errorMessage != "" ){
				ViewManager.openAlert( errorMessage );
				App.sessionStorage.remove('CIVICS', 'SSO_ERROR');
			}
			errorMessage = App.sessionStorage.get('CIVICS', 'LOGOUT_MESSAGE');
			if( errorMessage && errorMessage != "" ){
				ViewManager.openAlert( errorMessage );
				App.sessionStorage.remove('CIVICS', 'LOGOUT_MESSAGE');
			}


			if(this.config.isRedirect) {
				var error = {};
				error.validationError = {userloginform : i18n.t('PORTAL.LOGIN.SIGN_IN_REQUIRED') };
				ViewManager.errorToWindow(error, this.signinLayoutView);
			}
		},
		finalizeAuthentication: function() {
			var signinSettings = LoginChannel.request('signin:settings');

			//Clear session storage values specific to the user so we can now load new values for this user.
			ViewManager.clearUserSpecificSessionStorage();
			ViewManager.clearUserSpecificLocalStorage();
			
			App.sessionStorage.remove('CIVICS','CIVICS_DATA');
			LoginChannel.reset();
			// this.destroy();
			if (this.okCallback) {
				this.okCallback(this.okCallbackOptions);
			}
			if (!this.config.disableRedirectOnOk) {
				// Go to homepage or bookmarked URL
				// if($(".redirect-input").first().val() != "") {
				// 	window.location.assign($(".redirect-input").first().val());
				// } else {
				// 	window.location.assign(this.config.loginRedirectPage);
				// }
			}
		},
		template: tpl
	});
});
